module.exports = __webpack_public_path__ + "img/6.8ea3c042.jpg";